// This component displays the common 404 not found message,
// for alle undefined Routes
// Author: @SG

import React from 'react';

const NotFound = () => (
  <div>
    <h3>404 - Not found</h3> <hr />
    Diese Seite konnte nicht gefunden werden.
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js